import axios from 'axios'
import { clearActiveShop } from '@/context/shop-context'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

const isDebugEnv = ['LOCAL', 'DEVELOPMENT'].includes(import.meta.env.VITE_ENVIRONMENT)

api.interceptors.request.use((config) => {
  if (!isDebugEnv) return config
  return {
    ...config,
    params: { is_debug: true, ...config.params },
  }
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearActiveShop()
    }
    return Promise.reject(error)
  }
)
